module.exports = __webpack_public_path__ + "img/close.0cbe06d3.svg";